import i18next, { Resource } from "i18next";
import { detectLanguage, setAppLanguage } from "./utils";
import { DEFAULT_NAMESPACE } from "./constants";

export const i18n = function <Locale extends string = string>(
  resources: Resource,
  defaultNamespace: string = DEFAULT_NAMESPACE,
  fallbackLocale?: Locale
) {
  const i18nInstance = i18next.createInstance({});

  i18nInstance
    .use({
      type: "languageDetector",
      detect: detectLanguage,
      cacheUserLanguage: setAppLanguage,
    })
    .init({
      fallbackLng: (code) => {
        const fallbacks = [fallbackLocale as string];
        const pureLang = code.split("_")[0];

        if (pureLang !== code) {
          fallbacks.unshift(pureLang);
        }

        return fallbacks;
      },
      defaultNS: defaultNamespace,
      resources,
      react: {
        useSuspense: true,
        bindI18n: "added",
        bindI18nStore: "added",
      },
      detection: ["browser"],
    });

  return i18nInstance;
};
